"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Difficulty = void 0;
/**
 * The difficulty of a course.
 */
class Difficulty {
    constructor(id, name) {
        this._id = id;
        this._name = name;
    }
    static fromId(id, strict = true) {
        const difficulty = Difficulty._values.find((d) => d._id === id);
        if (difficulty) {
            return difficulty;
        }
        if (strict) {
            throw new Error(`Invalid difficulty id: ${id}`);
        }
    }
    static fromName(name, strict = true) {
        const difficulty = Difficulty._values.find((d) => d._name.toLowerCase() === name.toLowerCase());
        if (difficulty) {
            return difficulty;
        }
        if (strict) {
            throw new Error(`Invalid difficulty name: ${name}`);
        }
    }
    static fromRaw(raw, strict = true) {
        const parsedValue = parseInt(raw, 10);
        return isNaN(parsedValue)
            ? Difficulty.fromName(raw, strict)
            : Difficulty.fromId(parsedValue, strict);
    }
    toString() {
        return this._name;
    }
}
exports.Difficulty = Difficulty;
Difficulty.Easy = new Difficulty(0, 'Easy');
Difficulty.Normal = new Difficulty(1, 'Normal');
Difficulty.Hard = new Difficulty(2, 'Hard');
Difficulty.Oni = new Difficulty(3, 'Oni');
Difficulty.Edit = new Difficulty(4, 'Edit');
Difficulty.Ura = new Difficulty(4, 'Ura'); // alias
Difficulty.InnerOni = new Difficulty(4, 'InnerOni'); // alias
Difficulty.Tower = new Difficulty(5, 'Tower');
Difficulty.Dan = new Difficulty(6, 'Dan');
Difficulty._values = [
    Difficulty.Easy,
    Difficulty.Normal,
    Difficulty.Hard,
    Difficulty.Oni,
    Difficulty.Edit,
    Difficulty.Ura,
    Difficulty.InnerOni,
    Difficulty.Tower,
    Difficulty.Dan,
];
